module.exports = __webpack_public_path__ + "static/media/sitting by myself - 100px.e64f2a07.jpg";